export default __webpack_public_path__ + "static/media/academia_fester.f8cc551c.png";